import { postRequest, getRequest } from "../config/axiosConfig";

export interface TanResponse {
    success?: boolean;
    message?: string;
    [key: string]: any;
}

export interface ContinueJourneyResponse {
    status?: string;
    message?: string;
    data?: any;
    [key: string]: any;
}

class ContinueJourneyService {
    baseUrl: string;
    brand: string;

    constructor() {
        this.brand = process.env.REACT_APP_WEBSITE_BRAND || "vw";
        this.baseUrl = "";
    }

    // Send SMS with TAN Function
    async sendSmsWithTan(
        transactionId: string, 
        phoneNumber: string, 
        phoneCountryCode?: string
    ): Promise<TanResponse> {
        const url = `tan/${this.brand}/${transactionId}/generate`;
        
        try {
            const response = await postRequest(url, {
                phoneNumber,
                phoneCountryCode: phoneCountryCode || "+39",
            });
            return response.data as TanResponse;
        } catch (error) {
            console.error("Error sending SMS with TAN:", error);
            throw error;
        }
    }

    // Continue Journey Function
    async continueJourney(
        transactionId: string,
        tan: string
    ): Promise<ContinueJourneyResponse> {
        const url = `journey/${this.brand}/${transactionId}/continue`;
        
        try {
            const response = await postRequest(url, { tan });
            return response.data as ContinueJourneyResponse;
        } catch (error) {
            console.error("Error continuing journey:", error);
            throw error;
        }
    }

    // Get saved data for continue journey
    async getContinueJourneyData(
        transactionId: string,
        token?: string
    ): Promise<any> {
        const url = `saveForLater/${this.brand}/${transactionId}`;
        
        try {
            const response = await getRequest(url);
            return response.data;
        } catch (error) {
            console.error("Error getting continue journey data:", error);
            throw error;
        }
    }
}

export default ContinueJourneyService;

// Also export as named functions for convenience
const service = new ContinueJourneyService();
export const sendSmsWithTan = (transactionId: string, phoneNumber: string, phoneCountryCode?: string) => 
    service.sendSmsWithTan(transactionId, phoneNumber, phoneCountryCode);
export const continueJourney = (transactionId: string, tan: string) => service.continueJourney(transactionId, tan);
export const getContinueJourneyData = (transactionId: string, token?: string) => service.getContinueJourneyData(transactionId, token);
